import type { ActionTooltipTextSegment } from './ActionTooltip';
import { localizeSkillTag } from '../i18n/content';

const SKILL_TAG_COLORS: Record<string, string> = {
  poison: '#a855f7',
  movement: '#7dd3fc',
  fire: '#f97316',
  projectile: '#111111',
  healing: '#86efac',
  damage_over_time: '#fbbf24',
  ice: '#7dd3fc',
  melee: '#ffffff',
  area_of_effect: '#1e40af',
  lightning: '#fde047',
  support: '#38bdf8',
};

const DEFAULT_TAG_COLOR = '#9ca3af';

export function getSkillTagColor(tag: string): string {
  const normalizedTag = tag
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  return SKILL_TAG_COLORS[normalizedTag] ?? DEFAULT_TAG_COLOR;
}

export function createSkillTagStatLine(tags: string[]): ActionTooltipTextSegment[] {
  const segments: ActionTooltipTextSegment[] = [];
  for (let i = 0; i < tags.length; i += 1) {
    if (i > 0) {
      segments.push({ text: ', ' });
    }
    segments.push({ text: localizeSkillTag(tags[i]), color: getSkillTagColor(tags[i]) });
  }
  return segments;
}

export function localizeAndColorSkillTag(tag: string): ActionTooltipTextSegment {
  return {
    text: localizeSkillTag(tag),
    color: getSkillTagColor(tag),
  };
}
